import { printReport } from "@/lib/exportFile";
import { toast } from "sonner";
import { useMemo } from "react";
import { Printer } from "lucide-react";
import { useData } from "@/context/DataContext";
import { money } from "@/lib/money";

export default function MonthlyReport() {
  const { db, anchor, catInfo } = useData();
  const month = [anchor.getFullYear(), String(anchor.getMonth() + 1).padStart(2, "0")].join("-");
  const report = useMemo(() => {
    const expenses = db.expenses.filter((r) => r.date.startsWith(month));
    const incomes = db.incomes.filter((r) => r.date.startsWith(month));
    const saved = db.savings.filter((r) => r.date.startsWith(month));
    const by = {};
    expenses.forEach((r) => { by[r.cat] = (by[r.cat] || 0) + r.amt; });
    const sum = (items) => items.reduce((s, r) => s + r.amt, 0);
    return { expenses, incomes, saved, by, spent: sum(expenses), earned: sum(incomes), savings: sum(saved) };
  }, [db, month]);
  return <>
    <section className="mm-card mm-rise" aria-label="Monthly report">
      <h2 className="mm-h2 mb-2 text-lg">Monthly report</h2>
      <p className="mb-3 text-xs text-[var(--mu)]">Create a print-ready summary for {month}. Select “Save as PDF” in your browser's print dialog.</p>
      <button type="button" className="mm-btn ghost" onClick={async () => {
        const article = document.querySelector('.bp-print-report');
        const html = `<!doctype html><html><head><meta charset="utf-8"><style>body{font:14px sans-serif;color:#111;margin:24px}table{width:100%;border-collapse:collapse}td,th{padding:8px;border-bottom:1px solid #ddd;text-align:left}</style></head><body>${article.innerHTML}</body></html>`;
        try { await printReport(html); } catch (error) { toast.error(error.message); }
      }}><Printer size={16} /> Print / Save as PDF</button>
    </section>
    <article className="bp-print-report" aria-label="Printable financial report">
      <h1>BudgetPulse — Monthly report</h1>
      <p>Period: {month} | Currency: {db.settings.prefs.currency}</p>
      <p>Generated: {new Date().toLocaleDateString()}</p>
      <hr />
      <h2>Overview</h2>
      <table><tbody><tr><td>Income</td><td>{money(report.earned)}</td></tr><tr><td>Expenses</td><td>{money(report.spent)}</td></tr><tr><td>Savings movement</td><td>{money(report.savings)}</td></tr><tr><th>Net after savings</th><th>{money(report.earned - report.spent - report.savings)}</th></tr></tbody></table>
      <h2>Spending by category</h2>
      <table><tbody>{Object.entries(report.by).sort((a, b) => b[1] - a[1]).map(([id, amt]) => <tr key={id}><td>{catInfo(id).n}</td><td>{money(amt)}</td></tr>)}{!Object.keys(report.by).length && <tr><td colSpan="2">No spending recorded</td></tr>}</tbody></table>
      <p className="small">Personal budgeting summary. Not financial advice, a tax document or an audited statement. Verify figures before relying on them.</p>
    </article>
  </>;
}
